import {useGetData} from '../../src/apiservice/apiCall'


export function useContactInformation(){
	return useGetData('/api/WebApi/GetContactInformation')
}
